<script lang="ts">
    import {Button, Heading, Hr, Input, Label, Modal, Select, Spinner} from "flowbite-svelte";
    import type {Contract, ContractHistory, Employee} from "$lib/types/employee";
    import {getContext, onMount} from "svelte";
    import {formDataPost, get, post, put, retire} from "$lib/api";
    import {tariffs} from "$lib/stores/tariffs";
    import dayjs from "dayjs";
    import {contractTypes} from "$lib/utils/templating/contractTypes";
    import {asValue} from "$lib/utils/lenkradDate.js";
    import VerticalGrid from "$lib/components/VerticalGrid.svelte";
    import InfoBox from "$items/InfoBox.svelte";
    import EmployeeInfo from "$items/employee/EmployeeInfo.svelte";
    import TaxAndInsurance from "$items/employee/TaxAndInsurance.svelte";
    import Qualifications from "$items/employee/Qualifications.svelte";
    import BankAccount from "$items/employee/BankAccount.svelte";
    import CardLayout from "$items/CardLayout.svelte";
    import {allUnits} from "$lib/stores/unit";
    import NewContractForm from "$lib/partials/employee/NewContractForm.svelte";
    import {matchContractVariables} from "$lib/utils/templating/contractVariables";
    import wordDocumentParser from "$lib/utils/templating/wordDocumentParser";
    import {PUBLIC_API_PATH} from "$env/static/public";
    import {templateDocuments} from "$lib/stores/templateDocuments";
    import {getDocumentTemplates} from "$lib/calls/settings";
    import ModalHeader from "$lib/components/ui/ModalHeader.svelte";
    import ModalFooter from "$lib/components/ui/ModalFooter.svelte";
    import {type Writable, writable} from "svelte/store";
    import EmailTemplateEditor from "$lib/components/EmailTemplateEditor.svelte";
    import {mailTemplates} from "$lib/stores/mailTemplates";
    import {getEmailTemplates, sendEmailTemplate} from "$lib/calls/mail";
    import type {EmailTemplate} from "$lib/types/EmailTemplate";
    import {findUnmatchedVariables} from "$lib/utils/templating/parseHandlebars";
    import {getTariffs} from "$lib/calls/tariff";
    import {formatCurrency} from "$lib/utils/currency";
    import {PUBLIC_MAIL_FROM_EMAIL, PUBLIC_MAIL_FROM_NAME} from "$env/static/public";

    export let open: boolean = false;

    export let employee: Employee;

    export let contract: Contract;

    let proceedForm: HTMLFormElement;

    let formStatus = writable({
        loading: false,
        preview: null,
        formComplete: false,
        triggerPreview: false,
        triggerContract: false
    });

    let inputData: any = {
        link: 'https://goolge.com',
        localContractType: 'test',
        formerLocalContractType: contractTypes.find(t => t.value === contract.contractType).name,
        formerLink: null,
        formerEndDate: contract.currentHistory.endDate
    }

    let mailTemplate: EmailTemplate|undefined;

    let retireHistory: ContractHistory;

    let doneModal:Writable<boolean> = getContext('doneModal');

    let groups = [];

    let newContractModal = false;


    let newContract = {
        contractType: 'workingstudent',
        currentHistory: {
            id: null,
            startDate: dayjs().add(1, 'month').date(1).format('YYYY-MM-DD'),
            endDate: dayjs(asValue(contract.currentHistory.endDate)).format('YYYY-MM-DD'),
            tariffId: contract.currentHistory.tariffId,
            hiredAs: 'ServicehilfKraft',
            qualificationId: contract.currentHistory.qualificationId
        },
        history: undefined
    }
    let preview: Blob | null;
    const proceed = async () => {

        $formStatus.loading = true;
        const template = $templateDocuments.find(x => x.contractType === 'termination')
        const variables = matchContractVariables({
                ...employee,
                unit: $allUnits.find((u: any) => u.id === employee.unitId)},
            contract,
            {...contract.currentHistory, endDate: {value:dayjs(asValue(newContract.currentHistory.startDate)).subtract(1, 'day').format('YYYY-MM-DD')}},
            {}, {})
        if(!template) {
            alert('Fehlende Vorlage')
        } else {
            preview = await wordDocumentParser(PUBLIC_API_PATH + '/template-document/' + template.id + '/binary', variables)
        }

        inputData.formerEndDate = dayjs(asValue(newContract.currentHistory.startDate)).subtract(1, 'day').format('DD.MM.YYYY');
        if(!newContractModal){
            // scroll when first time
            setTimeout(() => {
                document.getElementById("new-contract")?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
            }, 600)
        }
        newContractModal = true;
        $formStatus.loading = false;


        console.log({inputData})
    }

    const retireContract = async () => {
        $formStatus.loading = true;
        retireHistory = await formDataPost(`/employee/${employee.uuid}/contract/${contract.id}/retire`, {
            endDate: dayjs(asValue(newContract.currentHistory.startDate)).subtract(1, 'day').format('YYYY-MM-DD'),
            external: false,
            file: preview
        })
        inputData.formerLink = retireHistory.employeeSignatureLink;
        $formStatus.loading = false;
    }
    const revertChanges = async () => {
        $formStatus.loading = true;
        $formStatus.triggerContract = false
        $formStatus.triggerPreview = false
        // destroy previews
        preview = null;
        $formStatus.preview = null;
        newContractModal = false;


        // revert retirement
        if(retireHistory){
            await retire(`/employee/${employee.uuid}/contract/${contract.id}/history/${retireHistory.id}?silent=true`)
        }
        // revert contract
        if(newContract.id && newContract.history.length > 0){
            await retire(`/employee/${employee.uuid}/contract/${newContract.id}/history/${newContract.history[0].id}?silent=true`)
        }
        newContract.history = undefined;

        $formStatus.loading = false;

    }
    const contractCreated = async (details:{contract: Contract, email:any}) => {
        // rerender retirement
        await proceed();
        inputData.localContractType = contractTypes.find(x => x.value === newContract.contractType)?.name
        await retireContract();
        // create TL
        await post('/employee/' + employee.uuid + '/timeline', {
            content: 'Vertragstypänderung eingeleitet'
        })
    }

    const sendEmail = async () => {
        $formStatus.loading = true
        try{
            const res = await sendEmailTemplate(mailTemplate.id, {
                fromEmail: PUBLIC_MAIL_FROM_EMAIL,
                fromName: PUBLIC_MAIL_FROM_NAME,
                subject: 'Vertrag_zwischen_' + employee.name + ' und Demo GmbH zur Signatur bereit!',
                entityId: employee.id,
                content: mailTemplate.content.replace(/<% body %>/g, ''),
                toEmail: employee.email,
                toName: employee.name,
                variables: findUnmatchedVariables(mailTemplate.content)
            })
            open = false
            $doneModal = true
        } catch (e) {

        } finally {
            $formStatus.loading = false
        }

    }

    onMount(async () => {
        if($allUnits.length === 0){
            $allUnits = await get('/units');
        }
        if($mailTemplates.length === 0){
            $mailTemplates = await getEmailTemplates()
        }

        mailTemplate = $mailTemplates.find(x => x.level === 'active' && x.name.toLowerCase().includes('vertragsart_sent'));
        if($templateDocuments.length === 0){
            $templateDocuments = await getDocumentTemplates()
        }
        if($tariffs.length === 0){
            $tariffs = await getTariffs();
        }
        groups = contractTypes.filter(x => ['shortterm', 'fulltime', 'parttime', 'workingstudent', 'minijob'].includes(x.value));
        console.log({groups, contractTypes})
    })
</script>
<Modal title="Vertragsart-Änderung}" size="xl" bind:open>
    <svelte:fragment slot="header">
        <ModalHeader>Vertragsart-Änderung</ModalHeader>
    </svelte:fragment>
    <div class="mt-3 space-y-3">
        <Heading tag="h3" class="text-neutral-600 pl-2">
            Bestehender Arbeitsvertrag  {employee.firstName} {employee.lastName}
        </Heading>

        <EmployeeInfo display={false} readOnly/>
        <Qualifications display={false} readOnly/>
        <TaxAndInsurance display={false} readOnly/>
        <BankAccount display={false} readOnly/>
    </div>

    <Hr/>
    <Heading tag="h3" class="text-neutral-600 pl-2">
        Neue Vertragsart  {employee.firstName} {employee.lastName}
    </Heading>
    <form bind:this={proceedForm} on:submit|preventDefault={proceed}>
        <CardLayout title="Vertragsart-Änderung" accordion >
<!--            <Heading tag="h3" class="mb-4 text-neutral-600">Neuer Vertrag {employee.firstName} {employee.lastName}</Heading>-->
            <VerticalGrid>
                <InfoBox title="Bestehender Grundlohn" value="{formatCurrency(employee.currentContract.currentHistory.wagePerHour, 'EUR')}" />
                <InfoBox title="Bestehende Akontozahlung" value="{formatCurrency(employee.currentContract.currentHistory.paymentOnAccount, 'EUR')}" />
                <InfoBox title="Status" value="{employee.status}" />
                <InfoBox title="Qualifikation" value="{contract.currentHistory.hiredAs}" />
                <InfoBox title="Bestehender Vertragsart" value="{contractTypes.find(x => x.value === employee.currentContract?.contractType)?.name}" />
                <InfoBox title="Auflösung bestehender Vertrag" value="{dayjs(asValue(newContract.currentHistory.startDate)).subtract(1, 'day').format('DD.MM.YYYY')}" />
                <svelte:fragment slot="right">
                    <InfoBox title="Zeitraum" value="{dayjs(asValue(contract.currentHistory.startDate)).format('DD.MM.YYYY')} - {dayjs(asValue(contract.currentHistory.endDate)).format('DD.MM.YYYY')}" />
                    <InfoBox title="Stunden" value="{contract.currentHistory.monthlyHours}" />
                    <InfoBox title="Unit" value="{$allUnits.find(x => x.id === employee.unitId)?.name }" />
                    <div class="h-12"></div>
                    <InfoBox title="Neuer Vertragsart" value="{contractTypes.find(x => x.value === newContract.contractType)?.name}" />
                    <InfoBox title="Beginn neuer Vertrag" value="{dayjs(asValue(newContract.currentHistory.startDate)).format('DD.MM.YYYY')}" />
                </svelte:fragment>
            </VerticalGrid>
            {#if !$formStatus.preview}
                <div class="flex gap-2 p-2 pt-4 mb-5">
                    <Label class="space-y-2 flex-1">
                        <span>Neuer Vertragsart</span>
                        <Select bind:value={newContract.contractType} >
                            {#each groups as group}
                                <option value={group.value} disabled={employee.currentContract?.contractType === group.value}>{group.name}</option>
                            {/each}
                        </Select>
                    </Label>
                    <Label class="space-y-2">
                        <span>Zum</span>
                        <Input on:change={() => newContract.currentHistory.startDate = dayjs(newContract.currentHistory.startDate).date(1).format('YYYY-MM-DD')} bind:value={newContract.currentHistory.startDate} type="date"/>
                    </Label>
                </div>
            {/if}

        </CardLayout>
    </form>
    {#if newContractModal && !newContract.currentHistory.id}
        <Heading id="new-contract" tag="h3" class="text-neutral-600 pl-2">
            Neuer Arbeitsvertrag  {employee.firstName} {employee.lastName}
        </Heading>
        <div>
            <CardLayout  title="Neue Vertragsdaten">
                <NewContractForm minTariffId={contract.currentHistory.tariffId} {employee} bind:sharedState={formStatus} on:history={({detail}) => contractCreated()}  bind:contract={newContract} {inputData} />
            </CardLayout>
        </div>
    {:else if newContract.history && retireHistory && inputData.formerLink}
        <EmailTemplateEditor on:update={(e) => {mailTemplate = e.detail}} preview={true} template={mailTemplate} fillData={{Employee: employee, Contract: newContract.history[0], Unit: $allUnits.find(x => x.id === (employee.unitId)), Input: inputData}}/>
    {/if}

    <svelte:fragment slot="footer">
        <ModalFooter disabled={$formStatus.loading} showEdit={!!preview} on:edit={() => revertChanges()} on:abort={() => {revertChanges(); open = false}}>
            <svelte:fragment slot="right">
                {#if preview}
                    <Button disabled={$formStatus.loading} class="!text-decoration-none whitespace-nowrap" download="Kündigung_{employee.name.replaceAll(' ','_')}.docx" href={URL.createObjectURL(preview)} target="_blank" color="light">Vorschau erzeugte Kündigung</Button>
                    {#if $formStatus.formComplete && !$formStatus.preview}
                        <Button disabled={$formStatus.loading} class="bg-sky-100 text-neutral-600 whitespace-nowrap" on:click={() => $formStatus.triggerPreview = true}>Vertragsvorschau erzeugen</Button>
                    {:else if $formStatus.formComplete && $formStatus.preview}
                        <Button disabled={$formStatus.loading} class="!text-decoration-none whitespace-nowrap" download="Vertragsangebot_{employee.name.replaceAll(' ','_')}.docx" href={URL.createObjectURL($formStatus.preview)} target="_blank" color="light">Vorschau erzeugter Vertrag</Button>
                        {#if newContract.currentHistory.id && retireHistory}
                            <Button disabled={$formStatus.loading} on:click={() => sendEmail()} class="bg-sky-100 text-neutral-600 whitespace-nowrap">Email versenden</Button>
                        {:else}
                            <Button class="bg-sky-100 text-neutral-600 whitespace-nowrap" disabled={$formStatus.loading} on:click={() => $formStatus.triggerContract = true}>Vertragsartänderung durchführen</Button>
                        {/if}
                    {/if}
                {:else}
                    <Button class="bg-sky-100 text-neutral-600 whitespace-nowrap" disabled={$formStatus.loading} on:click={() => proceedForm.requestSubmit()}>Vertragsangebot erstellen</Button>
                {/if}


            </svelte:fragment>
        </ModalFooter>
    </svelte:fragment>
</Modal>